var map = {
	"./article-btn.png": "a8ce",
	"./audio-btn.png": "d294",
	"./audio-selected.png": "f6b1",
	"./audio.png": "291c",
	"./back-black.png": "5763",
	"./btn-collect.png": "2826",
	"./btn-collected.png": "48e3",
	"./close-black.png": "5c0c",
	"./close.png": "44cf",
	"./digital-login.png": "222e",
	"./digital-mine.png": "ca7f",
	"./link-btn.png": "68e0",
	"./link-selected.png": "55b7",
	"./link.png": "b97a",
	"./next-black.png": "9c03",
	"./picture-btn.png": "0809",
	"./picture.png": "1083",
	"./prev-black.png": "b96a",
	"./read-black.png": "87ab",
	"./remove-btn.png": "8bf1",
	"./share-black.png": "0194",
	"./share-login.png": "3101",
	"./to-paper-en.png": "5132",
	"./to-paper.png": "0426",
	"./video-btn.png": "037e",
	"./video-selected.png": "f2a4",
	"./video.png": "b958",
	"./zIndex-bottom.png": "56f5",
	"./zIndex-down.png": "60b8",
	"./zIndex-top.png": "b34a",
	"./zIndex-up.png": "93a8",
	"./zIndex0.png": "3fb3",
	"./zIndex1.png": "fbdb"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "fcd4e";